import { Component } from '@angular/core';
import { KENDO_CARD } from '@progress/kendo-angular-layout';

@Component({
  selector: 'unity-card-summary-shared',
  imports: [KENDO_CARD],
  templateUrl: './card-summary-shared.component.html',
  styleUrl: './card-summary-shared.component.scss',
})
export class CardSummarySharedComponent {}
